define(function(require, exports, module) {
    'use strict';

    const _ = require('underscore');
    const util = require('utils');
    const unicode = require('util/unicode.util');
    const alphaReSrc = unicode.alphabeticRe.source;
    const ZipCityProvider = require('common/addressLookupSwiss/sourceProviders/zipCityProvider');
    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');
    const getDynamicTagValue = require('../../../../util/swiss-theme/dynamicTag.value.util');
    const cityStreetReSrc = '((?:(?:' + alphaReSrc + '{2,}|(?:^\\w[\'\u2019-])?' + alphaReSrc + '+)(?:(?:-|\'|\u2019|\\.\\s|\\s)' + alphaReSrc + '+)*)(?:-|\'|\u2019|\\.\\s?|\\s)?)';

    ZipCityProvider.prototype.prepareRequest = function(searchText, prevSearchResult) {
        const data = AbstractProvider.prototype.prepareRequest(searchText, prevSearchResult);
        const townName = this.cityRegEx.test(searchText) ? searchText : '';
        this.sortBy = townName && 'city';
        this.searchText = this.getSearchPattern()
            .exec(searchText.toLowerCase())
            .slice(1)
            .filter(Boolean)
            .map(function(str) {
                return str.trim();
            });

        const zipTownObj = _.extend(_.object(this.searchText.map(function(val) {
            return [isNaN(Number(val)) ? 'TownName' : 'Zipcode', val];
        })), {});

        data.request = {
            ...data.request,
            ...zipTownObj
        };

        return data;
    };

    ZipCityProvider.prototype.sort = function(rows) {
        const aReplacer = 'a1';
        const uReplacer = 'u2';
        const oReplacer = 'o3';
        const AReplacer = 'A1';
        const UReplacer = 'U2';
        const OReplacer = 'O3';
        const eReplacer = 'e4';
        const EReplacer = 'E4';
        const aUmlaut = 'ä';
        const uUmlaut = 'ü';
        const oUmlaut = 'ö';
        const AUmlaut = 'Ä';
        const UUmlaut = 'Ü';
        const OUmlaut = 'Ö';
        const eUmlaut = 'è';
        const EUmlaut = 'È';
        const substrings = ['ä', 'ü', 'ö', 'Ä', 'Ü', 'Ö', 'è', 'È'];
        const input = this.lastInput[0].toLowerCase();
        // Remove number and space from string.
        const inputTxt = this.lastInput.toLowerCase().replace(/[0-9]/g, '').trim();
        const inputLength = inputTxt.length;
        const fromStringToArray = inputTxt ? inputTxt.split('') : false;
        const isOnceUmlautExist = fromStringToArray && fromStringToArray.filter(el => substrings.includes(el)).length;
        const restrictedCity = getDynamicTagValue('RESTRICTEDCITY');
        const restrictedZip = getDynamicTagValue('RESTRICTEDZIP');

        if (isNaN(input)) {
            if (isOnceUmlautExist) {
                rows = _.filter(rows, function(el) {
                    if (el.city.toLocaleLowerCase().includes(inputTxt.toLocaleLowerCase())) {
                        return true;
                    }
                });
            } else {
                if (!substrings.some(input.includes.bind(input))) {
                    let replaceRow = _.each(rows, function(item) {
                        let city = item.city;
                        item.city = city
                            .replace(uUmlaut, uReplacer)
                            .replace(aUmlaut, aReplacer)
                            .replace(oUmlaut, oReplacer)
                            .replace(eUmlaut, eReplacer)
                            .replace(UUmlaut, UReplacer)
                            .replace(AUmlaut, AReplacer)
                            .replace(OUmlaut, OReplacer)
                            .replace(EUmlaut, EReplacer);
                    });

                    rows = _.filter(replaceRow, function(el) {
                        let firstChar = el.city.substring(0, inputLength).toLowerCase();
                        inputTxt.replace(uUmlaut, uReplacer)
                            .replace(aUmlaut, aReplacer)
                            .replace(oUmlaut, oReplacer)
                            .replace(eUmlaut, eReplacer)
                            .replace(UUmlaut, UReplacer)
                            .replace(AUmlaut, AReplacer)
                            .replace(OUmlaut, OReplacer)
                            .replace(EUmlaut, EReplacer);
                        if (inputTxt === firstChar) {
                            return true;
                        }
                    });

                    _.each(rows, function(row) {
                        let city = row.city;
                        row.city = city
                            .replace(uReplacer, uUmlaut)
                            .replace(aReplacer, aUmlaut)
                            .replace(oReplacer, oUmlaut)
                            .replace(eReplacer, eUmlaut)
                            .replace(UReplacer, UUmlaut)
                            .replace(AReplacer, AUmlaut)
                            .replace(OReplacer, OUmlaut)
                            .replace(EReplacer, EUmlaut);
                    });
                } else {
                    rows = _.filter(rows, function(el) {
                        let firstChar = el.city.substring(0, inputLength).toLowerCase();
                        input.replace(uUmlaut, uReplacer)
                            .replace(aUmlaut, aReplacer)
                            .replace(oUmlaut, oReplacer)
                            .replace(eUmlaut, eReplacer)
                            .replace(UUmlaut, UReplacer)
                            .replace(AUmlaut, AReplacer)
                            .replace(OUmlaut, OReplacer)
                            .replace(EUmlaut, EReplacer);
                        if (input === firstChar) {
                            return true;
                        }
                    });
                }
            }

            if (restrictedCity && restrictedCity.split(',')) {
                const cityArray = restrictedCity.split(',');
                rows = _.filter(rows, function(el) {
                    if (!cityArray.includes(el.city)) {
                        return true;
                    }
                });
            }
        } else if (restrictedZip && restrictedZip.split(',')) {
            const zipArray = restrictedZip.split(',');
            rows = _.filter(rows, function(el) {
                if (!zipArray.includes(el.zip)) {
                    return true;
                }
            });
        }

        return rows.sort(function(row1, row2) {
            return util.predicate.stringPredicate(row1.zip, row2.zip);
        });
    };

    ZipCityProvider.prototype.isValid = function(input) {
        return this.getSearchPattern().test(input);
    };

    ZipCityProvider.prototype.getSearchPattern = function() {
        const cityReSrc = cityStreetReSrc;
        return new RegExp('^(\\d{2,}\\s?)?' + cityReSrc + '?((?!^(?:' + cityReSrc + '|[-\\s.])+)\\d{2,})?$');
    };

    ZipCityProvider.prototype.format = function(row) {
        const inputTxt = this.lastInput.toLowerCase();
        return AbstractProvider.prototype.highlightResult.call(this, row.zip + ' ' + row.city, inputTxt);
    };

    module.exports = ZipCityProvider;
});
